import React from "react";
import styled from "styled-components";
// import Jimp from "jimp/es";
import Jimp from "jimp/browser/lib/jimp";
import JPEG from "jpeg-js";

export const state = {
  IDLE: "idle",
  LOADING: "loading",
  PROCESSING: "processing",
  DONE: "done",
  ERROR: "error"
};

Jimp.decoders["image/jpeg"] = (data) =>
  JPEG.decode(data, { maxMemoryUsageInMB: 1024 });

const StyledDropzoneContainer = styled.div`
  position: relative;
  font-size: 1.4rem;
  width: 24rem;
  height: 100vh;
  margin: 0 auto;
  color: #999;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .icon {
    margin-right: 0.8rem;
  }
`;

const StyledDropzone = styled.input`
  background-color: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-indent: -9999px;
  cursor: pointer;
`;

let currentState = state.IDLE;

export default function Importer({
  children,
  onDone = () => {},
  onStart = () => {},
  onUpdate = () => {}
}) {
  // const [importerState, setImporterState] = React.useState({
  //   total: 0,
  //   current: 0
  // });

  const transition = (newState) => {
    if (currentState === newState) return;

    currentState = newState;
  };

  const customUpload = (e) => {
    const files = e.target.files;
    const filesArr = Object.values(files);

    const _buffer = [];

    let _idx = 0;
    const _total = filesArr.length;

    transition(state.LOADING);

    onStart({
      data: [..._buffer],
      status: currentState,
      current: _idx,
      total: _total
    });

    const queueImageImport = (file, onLoaded) => {
      console.log("post to worker");

      file
        .arrayBuffer()
        .then((buffer) => {
          transition(state.PROCESSING);

          Jimp.read(buffer)
            .then((image) => {
              const width = image.bitmap.width;
              const height = image.bitmap.height;

              image
                .resize(1920, Jimp.AUTO)
                .getBase64Async(Jimp.MIME_JPEG)
                .then((data_url) => {
                  // Return object
                  onLoaded({ data_url, file });
                })
                .catch((err) => {
                  transition(state.ERROR);
                });
            })
            .catch((err) => {
              transition(state.ERROR);
              console.log(err);
            });
        })
        .catch((err) => {
          console.log("buffer", err);
          transition(state.ERROR);
        });
    };

    const onCompleted = () => {
      transition(state.DONE);

      onUpdate({
        data: [..._buffer],
        status: currentState,
        current: _idx,
        total: _idx
      });

      setTimeout(() => {
        transition(state.IDLE);

        onUpdate({
          data: [..._buffer],
          status: currentState,
          current: _idx,
          total: _idx
        });

        onDone(_buffer);
      }, 200);
    };

    const onLoaded = (image) => {
      _idx++;

      _buffer.push(image);

      onUpdate({
        data: [..._buffer],
        status: currentState,
        current: _idx,
        total: _total
      });

      if (_buffer.length === _total) {
        onCompleted();
        return;
      }

      queueImageImport(filesArr[_idx], onLoaded);
    };

    queueImageImport(filesArr[_idx], onLoaded);
  };

  return (
    <StyledDropzoneContainer>
      {children}
      <StyledDropzone
        accept="image/png, image/jpeg"
        type="file"
        onChange={customUpload}
        multiple
      />
    </StyledDropzoneContainer>
  );
}
